export default async el => {
    el.querySelector('.dropdown__toggle').addEventListener('click', function (e) {
        e.preventDefault();

        let selfClick = false;
        if (el.classList.contains('-open')) {
            selfClick = true;
        }

        const dropdowns = document.querySelectorAll('.dropdown.-open');
        dropdowns.forEach(async function (drop) {
            drop.classList.remove('-open');
        });

        if (!selfClick) {
            el.classList.toggle('-open');
        }
    });

};
